import { Col, Row } from '@opendoor/atoms/box';
import { Checkbox } from '@opendoor/atoms/checkbox';
import { Text } from '@opendoor/atoms/text';

export interface HomeTypeFilterProps {
  singleFamily?: boolean | null;
  townhome?: boolean | null;
  condo?: boolean | null;
  handleSingleFamilyChange: (_: string, checked: string | boolean) => void;
  handleTownhomeChange: (_: string, checked: string | boolean) => void;
  handleCondoChange: (_: string, checked: string | boolean) => void;
}

export const HomeTypeFilter = ({
  singleFamily,
  townhome,
  condo,
  handleSingleFamilyChange,
  handleTownhomeChange,
  handleCondoChange,
}: HomeTypeFilterProps) => {
  return (
    <Col className="w-full justify-between gap-5">
      <Text as="p" className="self-start text-label-xl text-od-content-primary">
        Home type
      </Text>
      <Row className="items-center justify-between">
        <Text as="p" className="text-body-md text-od-content-primary">
          Single-family homes
        </Text>
        <Checkbox
          aria-label="single-family-home-checkbox"
          analyticsName="sfh-checkbox"
          id="single-family-home-checkbox"
          name="singleFamily"
          value="true"
          checked={!!singleFamily}
          onCheckedChange={(checked) => handleSingleFamilyChange('singleFamily', checked)}
        />
      </Row>
      <Row className="items-center justify-between">
        <Text as="p" className="text-body-md text-od-content-primary">
          Townhomes
        </Text>
        <Checkbox
          aria-label="townhome-checkbox"
          analyticsName="townhome-checkbox"
          id="townhome-checkbox"
          name="townhome"
          value="true"
          checked={!!townhome}
          onCheckedChange={(checked) => handleTownhomeChange('townhome', checked)}
        />
      </Row>
      <Row className="items-center justify-between">
        <Text as="p" className="text-body-md text-od-content-primary">
          Condos
        </Text>
        <Checkbox
          aria-label="condo-checkbox"
          analyticsName="condo-checkbox"
          id="condo-checkbox"
          name="condo"
          value="true"
          checked={!!condo}
          onCheckedChange={(checked) => handleCondoChange('condo', checked)}
        />
      </Row>
    </Col>
  );
};
